import React from 'react';
import { bool, string } from 'prop-types';

import MapPinImage from './styles';

export default function MapPin({ color, imageUrl, offsetAnchor, unmapped }) {
  return (
    <MapPinImage
      offsetAnchor={offsetAnchor}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 300 420'
    >
      <circle cx='150' cy='152.73' r='128.44' style={{ fill: '#fff' }} />
      <path
        d='M639.77,301.67a150,150,0,0,0-150,150c0,142.78,150,270.18,150,270.18s150-127.4,150-270.18A150,150,0,0,0,639.77,301.67Zm0,281.17A128.45,128.45,0,1,1,768.22,454.4,128.45,128.45,0,0,1,639.77,582.84Z'
        transform='translate(-489.77 -301.67)'
        style={{ fill: unmapped ? 'var(--neutral-200)' : color }}
      />
      {imageUrl && !unmapped && (
        <g>
          <image
            width='200'
            height='200'
            transform='translate(60 62.33) scale(0.9)'
            xlinkHref={imageUrl}
          />
        </g>
      )}
      {unmapped && <MapPinImage.Slash d='M20.8205+282.96L264.589+31.6596' />}
    </MapPinImage>
  );
}

MapPin.defaultProps = {
  color: '#000',
  imageUrl: null,
  offsetAnchor: false,
  unmapped: false,
};

MapPin.propTypes = {
  color: string,
  imageUrl: string,
  offsetAnchor: bool,
  unmapped: bool,
};
